export default "__VITE_ASSET__9ydXi6zl__"